import React from "react";
import DashboardLayout from "../components/DashboardLayout";
import "../styles/ComingSoon.css";

const CreateDocument = () => {
  return (
    <DashboardLayout>
      <div className="coming-soon-fullscreen">
        <h1 className="coming-soon-title">🚧 Coming Soon</h1>
        <p className="coming-soon-subtext">This feature is currently in development.</p>
      </div>
    </DashboardLayout>
  );
};

export default CreateDocument;
